<template>
  <v-data-table
    v-if="calculos.length > 0"
    :headers="headers"
    :items="calculos"
    :items-per-page="5"
    class="elevation-1"
    :footer-props="{
      itemsPerPageAllText: 'Todos',
      itemsPerPageText: 'Cálculos por página'
    }"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Cálculos</v-toolbar-title>
        <v-spacer></v-spacer>
        <download-excel
          :data="calculos"
          name="sindecDebitosMultas.xls"
          :export-fields="camposExportar"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-2" fab dark x-small v-bind="attrs" v-on="on" color="green">
                <v-icon dark>mdi-file-excel-box</v-icon>
              </v-btn>
            </template>
            <span>Exportar cálculos para arquivo .xls</span>
          </v-tooltip>
        </download-excel>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              fab
              dark
              x-small
              v-bind="attrs"
              v-on="on"
              color="red"
              @click="exportarCalculosPDF()"
            >
              <v-icon dark>mdi-file-pdf-box</v-icon>
            </v-btn>
          </template>
          <span>Exportar cálculos para arquivo .pdf</span>
        </v-tooltip>
      </v-toolbar>
    </template>
    <template v-slot:header.jurosPre2020="{ header }">
      {{ header.text }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="#2f598b" dark small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
        </template>
        <span>
          Juros de 1% a.m. (arts. 212 a 214 do RI/TCDF, anterior à ER
          1/2019).
        </span>
      </v-tooltip>
    </template>
    <template v-slot:header.jurosPos2020="{ header }">
      {{ header.text }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="#2f598b" dark small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
        </template>
        <span>
          Juros e multa na forma da ER 1/2019 c/c LC 435/2001, art. 2º, §
          2º.
        </span>
      </v-tooltip>
    </template>
    <template v-slot:item.acoes="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mx-2"
            fab
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            color="red"
            @click="deletarCalculo(item)"
          >
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Excluir cálculo da lista.</span>
      </v-tooltip>
    </template>
    <template v-slot:footer.page-text="props">
      {{ props.pageStart }}-{{ props.pageStop }} de
      {{ props.itemsLength }}
    </template>
  </v-data-table>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  props: {
    nome: {
      type: String,
      default: "SINDEC"
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Data Original",
          align: "start",
          sortable: false,
          value: "dataValorOriginal"
        },
        { text: "Valor Original	", value: "valorOriginal" },
        { text: "Descrição", value: "descricao" },
        {
          text: "Data Incid. Juros",
          value: "dataJuros"
        },
        { text: "Data Atualização", value: "dataAtualizacao" },
        {
          text: "Atualização Monetária",
          value: "correcaoMonetaria"
        },
        { text: "Multa", value: "multa" },
        {
          text: "Juros Até 2019",
          value: "jurosPre2020"
        },
        {
          text: "Juros Pós-2019",
          value: "jurosPos2020"
        },
        { text: "Valor Corrigido", value: "valorCorrigido" },
        { text: "Ação", value: "acoes", sortable: false }
      ],
      camposExportar: {
        "Data do Valor Original": "dataValorOriginal",
        "Valor Original": "valorOriginal",
        Descrição: "descricao",
        "Data de Incidência de Juros": "dataJuros",
        "Data de Atualização": "dataAtualizacao",
        "Atualização Monetária": "correcaoMonetaria",
        Multa: "multa",
        "Juros até 2019": "jurosPre2020",
        "Juros após 2019": "jurosPos2020",
        "Valor Corrigido": "valorCorrigido"
      }
    };
  },
  computed: {
    calculos: function() {
      return this.$store.state.calculos;
    }
  },
  methods: {
    ...mapActions(["removeCalculo"]),
    deletarCalculo(item) {
      let indice = this.calculos.indexOf(item);
      this.removeCalculo(indice);
    },
    async exportarCalculosPDF() {
      const nomeCalculo = this.nome;

      let calculosOrdenados = Array();
        this.calculos.forEach(calculo => {
          calculosOrdenados.push([
            calculo.dataValorOriginal,
            calculo.valorOriginal,
            calculo.descricao,
            calculo.dataJuros,
            calculo.dataAtualizacao,
            calculo.correcaoMonetaria,
            calculo.multa,
            calculo.jurosPre2020,
            calculo.jurosPos2020,
            calculo.valorCorrigido
          ]);
        });

      // Salvar calculos no DB primeiro
      const dadosJson = JSON.stringify({
        calculos: calculosOrdenados,
        tipo: this.nome === 'Encargos Moratórios' ? 'encargosMoratorios' : 'debitosApuracao'
      });
      try {
        const response = await axios.post('/calculo', dadosJson, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.data.sucesso) {
          console.error('Falha ao salvar calculos');
          return;
        }
        
        const hash = response.data.hash;

        let valoresCalculos = calculosOrdenados.map(elemento =>
          Object.values(elemento)
        );

        let reducerSomatorios = (accumulator, currentValue) => {
          for (let index = 5; index < 10; index++) {
            accumulator[index] += parseFloat(
              currentValue[index]
                .substring(3)
                .replace(/\./g, "")
                .replace(/,/g, ".")
            );
          }
          return accumulator;
        };

        let somaValoresCorrigidos = valoresCalculos.reduce(reducerSomatorios, [
          "TOTAL",
          "",
          "",
          "",
          "",
          0,
          0,
          0,
          0,
          0
        ]);

        let formatadorMoeda = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          maximumFractionDigits: 2
        });

        for (let index = 5; index < 10; index++) {
          somaValoresCorrigidos[index] = formatadorMoeda.format(
            somaValoresCorrigidos[index]
          );
        }

        valoresCalculos.push(somaValoresCorrigidos);

        let hoje = new Date();
        var dataHoje =
          hoje.getDate() + "/" + (hoje.getMonth() + 1) + "/" + hoje.getFullYear();
        var horaHoje =
          hoje.getHours() + ":" + hoje.getMinutes() + ":" + hoje.getSeconds();

        let pdf = new jsPDF({
          orientation: "landscape"
        });
        pdf.autoTable({
          head: [
            [
              "Data Original",
              "Valor Original",
              "Descrição",
              "Data Juros",
              "Data C. M.",
              "C. Monetária",
              "Multa",
              "Juros até 2019",
              "Juros após 2019",
              "Valor Corrigido"
            ]
          ],
          body: valoresCalculos,
          didDrawPage: function(data) {
            // Header
            pdf.setFontSize(18);
            pdf.setTextColor(40);
            pdf.setFontStyle("normal");
            pdf.text(
              "TCDF - SINDEC - " + nomeCalculo + ". Exportação realizada em " +
                dataHoje +
                " às " +
                horaHoje,
              data.settings.margin.left,
              22
            );

            // Footer
            var str = "Página " + pdf.internal.getNumberOfPages();
            pdf.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = pdf.internal.pageSize;
            var pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
            pdf.text(str, data.settings.margin.left, pageHeight - 10);

            // Add link at the bottom center
            var link = "https://sindec.tc.df.gov.br/calculo/" + hash;
            var textWidth = pdf.getStringUnitWidth(link) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
            var textOffset = (pdf.internal.pageSize.width - textWidth) / 2;
            pdf.setTextColor(0, 0, 255);
            pdf.textWithLink(link, textOffset, pageHeight - 10, { url: link });
          },
          willDrawCell: function(data) {
            var rows = data.table.body;
            if (data.row.index === rows.length - 1) {
              pdf.setFillColor(0, 130, 183);
              pdf.setTextColor(255, 255, 255);
            }
            pdf.setFontSize(8);
          },
          margin: { top: 30 }
        });
        pdf.save("sindecDebitosMultas.pdf");
      } catch (error) {
        console.error("Erro ao salvar calculos:", error);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
